import { gql } from '@lcs/shared/api';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SaveMailboxMutation = gql`
   mutation SaveMailbox($mailbox: MailboxPostInput!) {
      mailbox: saveMailbox(mailbox: $mailbox) {
         mailboxId
         emailAddress
         discardAudioAfterEmail
         markReadAfterEmail
         isInNameDirectory
         sayCallerId
         password
         unavailablePromptId2
         temporaryUnavailablePromptId
         namePromptId
         operatorExtensionId
         busyPromptId
      }
   }
`;
